import React,{useState, useEffect}  from 'react';


import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Pidentifier(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Identifier Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python identifier tutorial for beginners.identifier blank space special symbol is not allowed,it must begin with a letters" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python identifiers,python identifier,python identifier rules,what is python identifier,python identifiers examples,python class identifier,python uuid identifier,python hardware identifier,python identifier scope" />
<link rel="canonical" href="https://www.codeexampler.com/python-identifiers" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Python identifier</h1>


    <div className="first">
        <a href="/python-types-of-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-keywords">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <h2 className="mt-4 mh2">Identifiers in python:</h2>
    <p className="mt-4 para">1. Uppercase, Lowercase and underscore can be used for as a initialization (for start)<br/>
    2. An Identifier can be combination of lowercase letters(a-b),Uppercase letters(A-Z),Digits(0-9)and Underscore(_)<br/>
    3. An Identifier never start with digits, if starts then it gives syntax error.<br/>
    4. Use of special symbol as identifier are not valid. <br/>
    5. Keywords can never be used as Identifier.<br/>
    6. Can not use Blank space within an Identifier.

<br/>
</p>

<h2 className="mt-4 mh2">Rules of identifier in Python :</h2>

<h2 className='headings'>1. Uppercase, Lowercase and underscore can be used for as a initialization (for start)</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">My_name</span>
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">my_name</span>
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">MY_NAME</span>
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">_My_Name</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 




<h2 className='headings'>2. An Identifier can be combination of lowercase letters(a-b),Uppercase letters(A-Z),Digits(0-9)and Underscore(_)</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">Myname_9</span>
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">my_9name</span>
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">_My_Name9</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  

         <h2 className='headings'>3. An Identifier never start with digits, if starts then it gives syntax error.</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">1My_name</span>
                 <span className="qwerty-1"> = "</span>
                 <span className="qwerty-3">Code Exampler</span>
                 <span className="qwerty-1">"</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty">SyntaxError</span>
                         <span className="qwerty-1">:</span>
                         <span className="qwerty-8">Invalid Syntax</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>         
         
      

                 <h2 className='headings'>4. Use of special symbol as identifier are not valid.</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">My@name</span>
                 <span className="qwerty-1"> = "</span>
                 <span className="qwerty-3">Code Exampler</span>
                 <span className="qwerty-1">"</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty">SyntaxError</span>
                         <span className="qwerty-1">:</span>
                         <span className="qwerty-8">Invalid Syntax</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

                 <h2 className='headings'>5. Keywords can never be used as Identifier.</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">for</span>
                 <span className="qwerty-1"> = "</span>
                 <span className="qwerty-3">Code Exampler</span>
                 <span className="qwerty-1">"</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty">SyntaxError</span>
                         <span className="qwerty-1">:</span>
                         <span className="qwerty-8">Invalid Syntax</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>    
          
        

<h2 className='headings'>6. Can not use Blank space within an Identifier.</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-1">&#62;&#62;&#62; </span>
                 <span className="qwerty-2">My name</span>
                 <span className="qwerty-1"> = "</span>
                 <span className="qwerty-3">Code Exampler</span>
                 <span className="qwerty-1">"</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty">SyntaxError</span>
                         <span className="qwerty-1">:</span>
                         <span className="qwerty-8">Invalid Syntax</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-types-of-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-keywords">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pidentifier;